import axios from '@/common/axios.config.js';
/**
 * 获取衍生品列表
 * @param {Object} payload: {pageNo: 1, pageSize: 10, sortType: 0}
 */
export function fetchGoodsList(payload) {
  return axios.post('derivation/list', payload);
}

/**
 * 获取演出推荐列表
 * @param {Object} payload: {vueneId: xxx, projectId: xxx, celebrityId: xxx}
 */
export function fetchReGoodsList(payload) {
  return axios.post('/derivation/relationlList', payload);
}